import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function DropshippingSpreadsheet() {
  return <ArticleLayout slug="dropshipping-spreadsheet" />;
}